import { useState } from "react";
import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";

const FAQ_ITEMS = [
  {
    question: "Comment réserver un taxi à Launaguet ?",
    answer:
      "Vous pouvez réserver votre taxi RSE TAXI à Launaguet en appelant le 06 52 62 07 47 ou en remplissant le formulaire de réservation en ligne sur notre site. Nous sommes disponibles 24h/24 et 7j/7 pour vos courses médicales, professionnelles et privées.",
  },
  {
    question: "RSE TAXI est-il conventionné CPAM pour les transports VSL ?",
    answer:
      "Oui, RSE TAXI est un taxi conventionné par la Sécurité Sociale (CPAM). Nous pratiquons le tiers payant pour les transports médicaux VSL. Vous n'avez aucune avance de frais à réaliser pour les transports pris en charge à 100% (ALD, accident du travail, maternité). Munissez-vous simplement de votre bon de transport et de votre carte vitale.",
  },
  {
    question: "Faites-vous des transports vers la Clinique de l'Union ?",
    answer:
      "Absolument ! RSE TAXI assure régulièrement des transports médicaux VSL vers la Clinique de l'Union à L'Union (31240), ainsi que vers le CHU Purpan, le CHU Rangueil, l'Oncopole et tous les établissements de santé de Toulouse et sa région. Transport conventionné CPAM avec tiers payant disponible.",
  },
  {
    question: "Quelles communes desservez-vous au nord de Toulouse ?",
    answer:
      "Basé à Launaguet, RSE TAXI dessert toute la zone 31 et notamment : Aucamville, Castelginest, Saint-Alban, Fenouillet, Fonbeauzard, Lespinasse, Gratentour, Bruguières, Pechbonnieu, Saint-Jory, L'Union, Castelmaurou, Montberon, Balma, Croix-Daurade et l'ensemble de l'agglomération toulousaine.",
  },
  {
    question: "Proposez-vous des transferts vers l'aéroport de Toulouse-Blagnac ?",
    answer:
      "Oui, nous assurons les transferts vers l'aéroport Toulouse-Blagnac et la gare Matabiau. Ponctualité garantie, suivi des horaires de vol, aide aux bagages. Facturation entreprise possible pour les professionnels.",
  },
  {
    question: "Comment fonctionne le tiers payant pour le transport médical ?",
    answer:
      "Pour bénéficier du tiers payant avec RSE TAXI, munissez-vous de votre prescription médicale (bon de transport) signée par votre médecin et de votre carte vitale à jour. Nous nous occupons de toutes les démarches administratives. Vous n'avez rien à payer pour les transports pris en charge à 100%.",
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section className="py-20 md:py-28 bg-secondary/30" id="faq" data-testid="faq-section">
      <div className="max-w-3xl mx-auto px-4 sm:px-6">
        <motion.div
          className="text-center mb-12"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
        >
          <span className="text-amber-400 font-tagline text-sm tracking-[0.3em] uppercase font-semibold">
            Besoin d'aide ?
          </span>
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-white mt-3">
            Questions fréquentes
          </h2>
          <p className="text-zinc-400 mt-3 text-base md:text-lg">
            Tout ce que vous devez savoir sur nos services de taxi au Nord de Toulouse.
          </p>
        </motion.div>

        <div className="space-y-3" itemScope itemType="https://schema.org/FAQPage">
          {FAQ_ITEMS.map((faq, i) => (
            <article
              key={i}
              className="border border-white/10 rounded-xl overflow-hidden bg-card/50"
              itemScope
              itemProp="mainEntity"
              itemType="https://schema.org/Question"
              data-testid={`faq-item-${i}`}
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between p-5 text-left transition-colors hover:bg-white/5"
                aria-expanded={openIndex === i}
              >
                <h3 className="text-sm md:text-base font-semibold text-white pr-4" itemProp="name">
                  {faq.question}
                </h3>
                <ChevronDown
                  className={`h-5 w-5 text-amber-400 flex-shrink-0 transition-transform duration-300 ${
                    openIndex === i ? "rotate-180" : ""
                  }`}
                />
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === i ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
                }`}
                itemScope
                itemProp="acceptedAnswer"
                itemType="https://schema.org/Answer"
              >
                <p className="px-5 pb-5 text-sm text-zinc-400 leading-relaxed" itemProp="text">
                  {faq.answer}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
